export const DrawerFilePortalId = "drawer-file-portal";
export const DialogFooterPortalId = "dialog-footer-portal";
export const LayoutPortalId = "portal-root";
export const WizardQuickSelectionPortalId = "wizard-quick-selection-portal";
export const EntityCreationLayoutLowerLeftPortalId = "entity-creation-lower-left-portal";
export const EntityCreationLayoutUpperLeftPortalId = "entity-creation-upper-left-portal";
export const EntityPreviewLayoutLowerLeftPortalId = "entity-preview-lower-left-portal";
export const EntityCreationLayoutFooterPortalId = "entity-creation-footer-portal";
export const MessagesId = "messages";
